import { CLOUDFRONT_URL } from '../../utils/urls';

const logoDict: { [key: string]: string } = {
  'Fintoc::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-fintoc.svg`,
  'Fintoc::Subscriptions::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-fintoc.svg`,
  'Khipu::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-khipu.png`,
  'TbkProxy::Webpay': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-webpay.png`,
  'Bank::Bsan::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-santander.png`,
  'Bank::Bci::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-bci.png`,
  'TbkProxy::OneClick': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-webpay_oneclick.png`,
  'TbkProxy::OneClickMall': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-webpay_oneclick.png`,
  'Bank::Bice::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-bice.png`,
  'Bank::Bchile::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-bancochile.png`,
  'Bank::Scotia::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-scotia.png`,
  'Bank::Itau::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-itau.png`,
  'TbkProxy::Pos': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-tbk-pos.png`,
  'Etpay::V1::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-etpay.svg`,
  'Getnet::Api::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-getnet.svg`,
  'Mach::Api::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-mach.png`,
  'ProntoPaga::Api::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-prontopaga.png`,
  'Kushki::Tokenized::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-kushki.png`,
  'Kushki::Tokenless::Plugin': `${CLOUDFRONT_URL}/payment-gateway/t1/logo-kushki.png`,
};

const bankLogoDict: { [key: string]: string } = {
  santander: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/santander_logo.svg`,
  bchile: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/bchile_logo.svg`,
  estado: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/estado_logo.png`,
  bci: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/bci_logo.png`,
  falabella: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/falabella_logo.png`,
  itau: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/itau_logo.png`,
  scotiabank: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/scotiabank_logo.png`,
  bice: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/bice_logo.svg`,
  security: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/security_logo.png`,
  ripley: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/ripley_logo.png`,
  consorcio: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/consorcio_logo.png`,
  internacional: `${CLOUDFRONT_URL}/payment-gateway/t1/banks/internacional_logo.png`,
};

const cardLogoDict: { [key: string]: string } = {
  RedCompra: `${CLOUDFRONT_URL}/payment-gateway/t1/cards/redcompra.png`,
  AmericanExpress: `${CLOUDFRONT_URL}/payment-gateway/t1/cards/americanexpress.png`,
  Visa: `${CLOUDFRONT_URL}/payment-gateway/t1/cards/visa.png`,
  MasterCard: `${CLOUDFRONT_URL}/payment-gateway/t1/cards/mastercard.png`,
};

const paymentMethodLogoSearch = (handler: string) => {
  if (!(handler in logoDict)) {
    return '';
  }
  return logoDict[handler];
};

const bankLogoSearch = (slug: string) => {
  const banks = Object.keys(bankLogoDict);
  const lowerCaseSlug = slug.toLowerCase();

  const matchedBank = banks.find((bank) => lowerCaseSlug.includes(bank)) || '';

  if (!(matchedBank in bankLogoDict)) {
    return '';
  }
  return bankLogoDict[matchedBank];
};

const subscriptionCardLogoSearch = (cardType: string) => {
  if (!(cardType in cardLogoDict)) {
    return `${CLOUDFRONT_URL}/payment-gateway/t1/cards/default.png`;
  }
  return cardLogoDict[cardType];
};

const logoSearcher = (
  key: string,
  slug: string,
  isCard: boolean,
  isTef: boolean
) => {
  if (isCard) {
    return subscriptionCardLogoSearch(key);
  }
  if (isTef) {
    return bankLogoSearch(slug);
  }
  return paymentMethodLogoSearch(key);
};

export default logoSearcher;
